<template>
  <div class="align-center-main">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>{{ serviceMsg.serviceName }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ serviceChildName }}</el-breadcrumb-item>
    </el-breadcrumb>
    <ul class="nav clearfix">
      <li v-for="(item, index) in serviceList" :key="index" class="boxShadow" :class="{ 'Select': selectIndex === item.serviceId }" @click="goMenu(item.type, item.serviceId)">
        <img :src="item.picUrl" alt="">
        <span class="textOver"> {{ item.serviceName }} </span>
      </li>
    </ul>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      selectIndex: 0,
      serviceList: [],
      serviceMsg: {},
    }
  },
  watch: {
    $route() {
      this.selectIndex = parseInt(this.$route.params.serviceId || this.$route.params.otherId)
    }
  },
  methods: {
    goMenu(type, serviceId) {  // 路由定向
      this.selectIndex = parseFloat(serviceId);
      switch (type) {
        case 11:
          this.$router.push({ path: `/navigator/businessPlatform/businessNav/recommended/${serviceId}` });
          break;
        case 12:
          this.$router.push({ path: `/navigator/businessPlatform/businessNav/meetingRoom/${serviceId}` });
          break;
        case 16:
          this.$router.push({ path: `/navigator/businessPlatform/businessNav/other/${serviceId}` });
          break;
        default:
          break;
      }
    },
    getServiceList() {  // 获取商务平台列表
      this.$http.post(`${this.URL_PREFIX}/app/get/park/service/list`, {
        parkId: this.currentParkId,
        parentId: this.serviceMsg.serviceId,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.serviceList = res.resData.pageList ? res.resData.pageList : [];
          let path = this.$route.path.split('/')[4] ? this.$route.path.split('/')[4] : false ;
          const id = this.$route.path.split('/')[4] && this.$route.path.split('/')[5] ? this.$route.path.split('/')[5] : this.serviceList[0].serviceId;
          switch (path) {
            case 'recommended':
              this.goMenu(11, id);
              break;
            case 'meetingRoom':
              this.goMenu(12, id);
              break;
            case 'other':
              this.goMenu(16, id);
              break;
            default:
              this.goMenu(this.serviceList[0].type, id);
              break;
          }
        }
      });
    },
  },
  computed: {
    ...mapGetters(['currentParkId', 'parkServiceList']),
    serviceChildName() {
      const arrIndex = this.serviceList.findIndex((val) => {
        return this.selectIndex === val.serviceId;
      });
      if (arrIndex !== -1) {
        return this.serviceList[arrIndex].serviceName;
      }
      return '';
    }
  },
  created() {
    if (this.parkServiceList.length) {
      this.serviceMsg = this.parkServiceList.find((val) => {
        return val.serviceFlag === 2;
      });
      this.getServiceList();
    }
  },
}
</script>


<style lang="scss" scoped>
.nav {
  margin-bottom: 20px;
  li {
    float: left;
    height: 86px;
    width: 284px;
    margin-right: 20px;
    margin-bottom: 20px;
    background-color: #fff;
    font-size: 24px;
    box-sizing: border-box;
    color: #333;
    border: 1px solid #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 44px;
    &:nth-of-type(4n) {
      margin-right: 0;
    }
    &.Select{
      border-color: #d9262c;
    }
    img {
      width: 44px;
      height: 44px;
      margin-right: 20px;
    }
    span {
      display: inline-block;
      // width: 180px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/navigator/businessPlatform/child/BusinessNav.vue